// extracted by mini-css-extract-plugin
export default {"wrapper":"ForgotPasswordForm_wrapper__oCfko","action":"ForgotPasswordForm_action__8ZLuP","form":"ForgotPasswordForm_form__W+4Z4","info":"ForgotPasswordForm_info__hXGr6"};